import { useMemo } from "react";

import Form from "antd/es/form";
import { FormInstance } from "antd/es/form/Form";

import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";

import { OrganizationDetailsTabs } from "@app/enum/settings/SettingPath";
import ActivitiesSettings from "@app/scene/settings/type/ActivitiesSettings";
import DataSettings from "@app/scene/settings/type/DataSettings";
import DealsSettings from "@app/scene/settings/type/DealsSettings";
import DefaultColumnsSettings from "@app/scene/settings/type/DefaultColumnsSettings";
import GeneralSettings from "@app/scene/settings/type/GeneralSettings";
import LeaderboardSettings from "@app/scene/settings/type/LeaderboardSettings";
import LeadGenSettings from "@app/scene/settings/type/LeadGenSettings";
import MapSettings from "@app/scene/settings/type/MapSettings";
import MileageTrackingSettings from "@app/scene/settings/type/MileageTrackingSettings";
import ResourcesSettings from "@app/scene/settings/type/ResourcesSettings";

const usePageControllers = (tab: OrganizationDetailsTabs) => {
  const [isDirty, setDirty, unsetDirty] = useBoolean();
  const [generalForm] = Form.useForm<GeneralSettings>();
  const [activitiesForm] = Form.useForm<ActivitiesSettings>();
  const [leadGenerationForm] = Form.useForm<LeadGenSettings>();
  const [leaderboardRankForm] = Form.useForm<LeaderboardSettings>();
  const [dataForm] = Form.useForm<DataSettings>();
  const [mapForm] = Form.useForm<MapSettings>();
  const [mileageTrackingForm] = Form.useForm<MileageTrackingSettings>();
  const [resourcesForm] = Form.useForm<ResourcesSettings>();
  const [defaultColumnsForm] = Form.useForm<DefaultColumnsSettings>();
  const [dealsForm] = Form.useForm<DealsSettings>();

  return useMemo(() => {
    const formMap: Record<OrganizationDetailsTabs, FormInstance> = {
      [OrganizationDetailsTabs.ACTIVITIES]: activitiesForm,
      [OrganizationDetailsTabs.DATA]: dataForm,
      [OrganizationDetailsTabs.DEALS]: dealsForm,
      [OrganizationDetailsTabs.DEFAULT_COLUMNS]: defaultColumnsForm,
      [OrganizationDetailsTabs.GENERAL]: generalForm,
      [OrganizationDetailsTabs.LEAD_GENERATION]: leadGenerationForm,
      [OrganizationDetailsTabs.LEADERBOARD]: leaderboardRankForm,
      [OrganizationDetailsTabs.MAP]: mapForm,
      [OrganizationDetailsTabs.MILEAGE_TRACKING]: mileageTrackingForm,
      [OrganizationDetailsTabs.RESOURCES]: resourcesForm,
    };

    const form = formMap[tab];
    const handleUndo = () => {
      form.resetFields();
      unsetDirty();
    };

    return { form, handleUndo, isDirty, setDirty, unsetDirty };
  }, [
    activitiesForm,
    dataForm,
    dealsForm,
    defaultColumnsForm,
    generalForm,
    leadGenerationForm,
    leaderboardRankForm,
    mapForm,
    mileageTrackingForm,
    resourcesForm,
    tab,
    isDirty,
    setDirty,
    unsetDirty,
  ]);
};

export default usePageControllers;
